var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircleGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11254 5.08263C6.865 5.33058 6.66874 5.62488 6.53499 5.9487C6.40123 6.27253 6.3326 6.61954 6.33301 6.9699C6.33301 7.13312 6.39785 7.28965 6.51326 7.40507C6.62867 7.52048 6.78521 7.58532 6.94842 7.58532C7.11164 7.58532 7.26818 7.52048 7.38359 7.40507C7.499 7.28965 7.56384 7.13312 7.56384 6.9699C7.56284 6.78106 7.59931 6.59389 7.67114 6.41923C7.74297 6.24458 7.84874 6.08591 7.98232 5.95242C8.25684 5.69152 8.62109 5.54605 8.99981 5.54605C9.37853 5.54605 9.74277 5.69152 10.0173 5.95242C10.2218 6.1528 10.3618 6.40975 10.4192 6.69027C10.4766 6.97079 10.4488 7.26207 10.3395 7.52669C10.2301 7.79131 10.0441 8.01719 9.80538 8.17531C9.56667 8.33344 9.28613 8.41658 8.99981 8.41408C8.83725 8.4162 8.68195 8.48172 8.56699 8.59668C8.45204 8.71163 8.38652 8.86694 8.38439 9.02949V9.85005C8.38439 10.0133 8.44923 10.1698 8.56464 10.2852C8.68006 10.4006 8.83659 10.4655 8.99981 10.4655C9.16303 10.4655 9.31956 10.4006 9.43497 10.2852C9.55038 10.1698 9.61522 10.0133 9.61522 9.85005V9.57106C10.0973 9.46071 10.5383 9.21604 10.8871 8.86538C11.3862 8.36407 11.6663 7.68549 11.6663 6.97811C11.6663 6.27073 11.3862 5.59215 10.8871 5.09084C10.3788 4.60605 9.70383 4.33491 9.00145 4.33338C8.29906 4.33185 7.6229 4.60006 7.11254 5.08263V5.08263Z",
    fill: "#B0B0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0003 13.124C9.56678 13.124 10.026 12.6648 10.026 12.0983C10.026 11.5318 9.56678 11.0726 9.0003 11.0726C8.43383 11.0726 7.97461 11.5318 7.97461 12.0983C7.97461 12.6648 8.43383 13.124 9.0003 13.124Z",
    fill: "#B0B0B0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircleGray);
export default __webpack_public_path__ + "static/media/question-circle-gray.f288ddb6aebfd4c13cf1d174275e04a3.svg";
export { ForwardRef as ReactComponent };